export default () => {
  const userAgent = navigator.userAgent.toLowerCase()
  // 常见移动设备关键字
  const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'windows phone', 'blackberry', 'tablet', 'mobile', 'kindle', 'silk', 'opera mini', 'opera mobi']
  return mobileKeywords.some(keyword => userAgent.includes(keyword))
}



// WEBPACK FOOTER //
// ./src/utils/isMobile.js